import {BaseActionClassModel} from "../../base-action-class.model";
import {ActionEnum} from "../../action.enum";

export namespace ObjectClassAction {

  export enum OCAClassBasisInfoTypeStep {
    SELECT_BASIS_INFO_TYPE = "SELECT_BASIS_INFO_TYPE",
    ADD_BASIS_INFO_VALUE = "ADD_BASIS_INFO_VALUE"
  }

  export class DefaultInfoDialogVisibility extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.OBJECT_CLASS_BULK_DIALOG_VISIBILITY;

    constructor(public visible: boolean) {
      super(null);
    }
  }

}
